import { createReducer, on } from '@ngrx/store';
import * as ProjectActions from './senAppProjects.action';
import { state } from '@angular/animations';
import { ProjectBrowseData } from "../common/api/ProjectBrowse";

export interface AppState {
    allProjects?: ProjectBrowseData;
    selectedProject?: any;
    nonUsableAreas: any;
    panelCount: any;
    resetPanelShow: any,
    collapseIndex: any
}

const initialState: AppState = { nonUsableAreas: { show: false }, panelCount: { count: 0 }, resetPanelShow: false, collapseIndex: 1 };

export const _projectReducer = createReducer(
    initialState,
    on(ProjectActions.loadProjects, (state: any, action: any) => { return state }),
    on(ProjectActions.loadProjectsSuccess, (state, projects: any) => ({ ...state, allProjects: projects.projects?.ok?.data })),
    on(ProjectActions.selectProject, (state: any, action: any) => { return state }),
    on(ProjectActions.selectProjectSuccess, (state, selectedProject: any) => ({ ...state, selectedProject: selectedProject.selectedProject?.ok?.data })),
    on(ProjectActions.addKWToProject, (state, selectedProject: any) => ({ ...state, selectedProject: selectedProject })),
    on(ProjectActions.clearSelectProject, (state: any) => ({ ...state, selectedProject: null })),
    on(ProjectActions.clearAllProjects, (state: any) => ({ ...state, allProjects: null })),
    on(ProjectActions.addSelectedPlan, (state: any, plan: any) => ({ ...state, selectedPlan: plan })),
    on(ProjectActions.clearSelectedPlan, (state: any) => ({ ...state, selectedPlan: null })),
    on(ProjectActions.getAllInverters, (state: any, inverters: any) => ({ ...state, allInverters: inverters['0'] })),
    on(ProjectActions.panelCountForPanelPage, (state: any, panelCount: any) => ({ ...state, panelCount: panelCount })),
    on(ProjectActions.PanelsDrawnAtInvStrings, (state: any, panelsDrawn: any) => ({ ...state, panelsDrawn: panelsDrawn })),
    on(ProjectActions.resetPanelShowForPanelPage, (state: any, resetPanelShow: boolean) => ({ ...state, resetPanelShow: resetPanelShow })),
    on(ProjectActions.collapseIndexForPanelPage, (state: any, collapseIndex: number) => ({ ...state, collapseIndex: collapseIndex })),
    on(ProjectActions.detailsOfNonUsableAreas, (state: any, nonUsableAreas: any) => ({ ...state, nonUsableAreas: nonUsableAreas })),
    on(ProjectActions.selectedInverterCom, (state: any, inverterCom: any) => ({ ...state, inverterCombo: inverterCom })),
    on(ProjectActions.selectedInverterEdit, (state, selectedInverter: any) => ({ ...state, selectedInverter: selectedInverter })),
    on(ProjectActions.clearInverterEdit, (state) => ({ ...state, selectedInverter: null })),
);

export function ProjectReducer(state: any, action: any) {
    return _projectReducer(state, action);
}